/**
* LoginFormMdule is a reusable Module to use the login module features
*/

// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// Own Components
import { ButtonComponent } from './button.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ButtonComponent
    ],
    exports: [
        ButtonComponent
    ]
})

export class ButtonModule { }
